/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NumberClaimValue: core.serialization.ObjectSchema<
    serializers.NumberClaimValue.Raw,
    Truvity.NumberClaimValue
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace NumberClaimValue {
    export interface Raw {
        value: number;
    }
}
